import { sendGAEvent } from '../marketing/gtm-provider';
import { getIsAuthenticated } from '../hidden-data-provider';

window.addEventListener('DOMContentLoaded', (event) => {

    if(!window.dataLayer) return;

    const $elements= document.querySelectorAll('[data-gaevent]') as NodeListOf<HTMLElement>;

    $elements.forEach(($el) => {

        $el.addEventListener('click', (evt) => {
            const $current = evt.currentTarget as HTMLElement;
            const eventTitle = $current.getAttribute('data-gaevent') || '';
            let eventValue = $current.getAttribute('data-gavalue') || '';

            // handle https://wavesaudio.atlassian.net/browse/DSWEB-3069
            const download = $current.getAttribute('data-gavalue-download') || '';
            if(download){
                eventValue = download;
                if(!getIsAuthenticated()){
                    eventValue += ' Redirect'
                }
            }

            sendGAEvent(eventTitle, eventValue);
        });
    });

});

export {};